/**
 * @file paddlex 用户信息hooks
 * @author zhangyan(zhangyan95@baidu.com)
 */
import { useCallback, useState, useEffect } from 'react';
import { Form, message, RadioChangeEvent } from 'antd';
import { useHistory } from 'react-router-dom';

// import { useVerifyCode } from '../../../../components/verify-code/verifyCodeHooks';
import { fetchSubmitCustomerInfo } from '../../../../api/pages/installApi';
import { getCmsDataInfo } from '../../../../api/pages/paddleCmsGetDataApi';
import industryMap from '../../../paddlex/pages/user-info/data/industryMap.json';
import { industryItem } from './type';

const useUserInfoHooks = () => {
    const history = useHistory();
    const historyPush = history.push;

    // const { verifyCodeImg, randomStr, verifyCodeLoading, getVerifyCode } = useVerifyCode();
    const [userInfoForm] = Form.useForm();
    const { setFields } = userInfoForm;

    // const randomStrRef = useRef<string>(randomStr);
    // randomStrRef.current = randomStr;

    //标识是否选择其他行业
    const [careerType, setCareerType] = useState<number>(1);
    const handleCareerTypeChange = (e: RadioChangeEvent) => {
        setCareerType(e.target.value);
    };
    //删除最后json数组最后一项‘其他行业’
    const [industryData, setIndustryData] = useState<industryItem[]>(() => {
        let tempIndustryMap: industryItem[] = [];
        tempIndustryMap = industryMap.filter(item => item.text !== '其他行业');
        return tempIndustryMap;
    });

    // whl下载包映射表
    const [pkgMap, setPkgMap] = useState<{ [key: string]: string }>({});

    const [selectOpen, setSelectOpen] = useState(false);
    //用户自定义添加行业
    const [industryInput, setIndustryInput] = useState<string>('');
    const onIndustryInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIndustryInput(event.target.value);
    };
    const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        e.preventDefault();
        if (industryInput !== '') {
            setIndustryData([{ value: industryInput, text: industryInput }, ...(industryData || `New item`)]);
            setIndustryInput('');
            setFields([
                {
                    name: 'industry',
                    value: industryInput
                }
            ]);
            setSelectOpen(false);
        }
    };

    //处理返回逻辑
    const [isSuccess, setIsSuccess] = useState(false);
    const [time, setTime] = useState<number>(5);
    const [resultMessage, setResultMessage] = useState<string>('');

    useEffect(() => {
        setTimeout(() => {
            if (isSuccess) {
                if (time === 1) {
                    historyPush(`/install/other`);
                    window.scrollTo(0, 0);
                } else if (time > 0) {
                    setTime(time => time - 1);
                }
            }
        }, 1000);
    }, [time, historyPush, isSuccess]);
    //表单提交
    const onFormSubmit = useCallback(
        async (values: any) => {
            const urlSearch = new URLSearchParams(window.location.search.slice(1));
            const key = urlSearch.get('pkg');
            const pkgMapValue = key ? pkgMap[key] : 'xx';
            const tempFilterParams = {
                classify: urlSearch.get('classify') ?? '',
                ai: urlSearch.get('ai') ?? '',
                cpu: urlSearch.get('cpu') ?? '',
                sdk: urlSearch.get('sdk') ?? '',
                os: urlSearch.get('os') ?? '',
                package: pkgMapValue ?? ''
            };

            console.log('tempFilterParams', tempFilterParams);

            const res = await fetchSubmitCustomerInfo({
                ...tempFilterParams,
                ...values,
                // randomStr: randomStrRef.current,
                source: urlSearch.get('source') || ''
            });
            if (res && res.body) {
                if (res.body?.errorCode === 0) {
                    // whl下载包执行逻辑
                    const key = urlSearch.get('pkg');
                    if (key) {
                        setIsSuccess(true);
                        const downUrl = pkgMap[key];
                        if (downUrl) {
                            window.location.href = downUrl;
                            setResultMessage('安装包已自动下载');
                        } else {
                            setResultMessage('百度飞桨团队将在24小时内与您联系，请您耐心等待！');
                        }
                    }
                } else if (res.body.errorCode === 500 && res.body.errorMsg === '验证码错误') {
                    setFields([
                        {
                            name: 'verifyCode',
                            errors: [res.body.errorMsg]
                        }
                    ]);
                    // getVerifyCode();
                } else {
                    (window as any).DEBUG && message.error(res.body.errorMsg);
                    // getVerifyCode();
                }
            }
        },
        [setFields, pkgMap]
    );

    const historyGoBack = history.goBack;
    const onFormCancel = useCallback(() => {
        historyGoBack();
    }, [historyGoBack]);

    //获取资源包
    useEffect(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/pkgmap' }).catch(err => console.log(err));
            if (res) {
                let tempObj: { [key: string]: string } = {};
                const list = (res.body.result?.pageData?.pkgMap?.list || []) as { key: string; link: string }[];
                list.forEach(item => {
                    tempObj[item.key] = item.link;
                });
                setPkgMap(tempObj);
            }
        })();
    }, []);

    return {
        isSuccess,
        time,
        resultMessage,
        pkgMap,
        // verifyCodeImg,
        // getVerifyCode,
        // randomStr,
        // verifyCodeLoading,
        careerType,
        userInfoForm,
        onFormSubmit,
        onFormCancel,
        handleCareerTypeChange,
        industryInput,
        setIndustryInput,
        onIndustryInputChange,
        industryData,
        addItem,
        selectOpen,
        setSelectOpen
    };
};

export default useUserInfoHooks;
